import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_THIRD_PARTY_ACCESS: MijnRoute = {
    path: 'toegang-derden-beheren',
    navigationEvent: 'toToegangDerdenBeheren',
    regex: /^\/zelf-regelen\/toegang-derden-beheren$/,
    webcomponent: 'mijn-klant-toegang-derden-beheer'
};
